import { InsuranceType, MainPath } from "Constants/constants";

import { Step } from "@storebrand-digital/insurance-stepper";
import { CHECKOUT_STEPS } from "Components/Features/CheckOut/checkoutSteps";

export const PATH = `/${MainPath.CHECK_PRICE}/${InsuranceType.VALUABLE}`;

export const VALUABLE_ABOUT: Step = {
  id: "om-gjenstanden",
  title: "Din verdisak",
  ariaLabel: `${MainPath.CHECK_PRICE}-om-gjenstanden`,
  complete: false,
};

export const VALUABLE_PRICE: Step = {
  id: "product-price",
  title: "Sjekk pris",
  ariaLabel: `${MainPath.CHECK_PRICE}-product-price`,
  complete: false,
};

export const VALUABLES_STEPS = [
  VALUABLE_ABOUT,
  VALUABLE_PRICE,
  ...CHECKOUT_STEPS,
];

export enum ProductCategory {
  NATIONAL_COSTUME = "NATIONAL_COSTUME",
  CAMERA = "CAMERA",
  HEARING_AID = "HEARING_AID",
  COMPUTER_EQUIPMENT = "COMPUTER_EQUIPEMENT",
  FUR_COAT = "FUR_COAT",
  GOLF_EQUIPEMENT = "GOLF_EQUIPEMENT",
  FIREARM = "FIREARM",
  BIKE = "BIKE",
  EL_BIKE = "EL_BIKE",
  OTHER = "OTHER",
}

export const validProducts = Object.values(ProductCategory).filter(
  (product) => product !== ProductCategory.OTHER,
);

export enum ValuablesInsuranceType {
  VALUABLES = "VALUABLES",
}
